import React, { useState, useEffect, useMemo } from 'react'
import { Button, Layout, Tag, Tooltip } from 'antd'
import { Auth } from 'aws-amplify'
import { useHistory } from 'react-router-dom'
import OMSLogo from 'src/assets/images/OMSLogoWht.png'
import { H4 } from 'src/branding/typography'
import styled, { css } from 'styled-components/macro'
import { Link as ReactLink } from 'react-router-dom'
import OrdersIcon from '../../components/icons/OrdersIcon'
import ProductsIcon from '../../components/icons/ProductsIcon'
import CustomersIcon from '../../components/icons/CustomersIcon'
import FeedbackIcon from '../../components/icons/FeedbackIcon'
import InvoicesIcon from '../../components/icons/InvoicesIcon'
import CopilotIcon from '../../components/icons/CopilotIcon'
import SignoutIcon from '../../components/icons/SignoutIcon'
import IncentiveIcon from '../../components/icons/IncentiveIcon'
import IntegrationIcon from '../../components/icons/IntegrationIcon'
import MarketingIcon from '../../components/icons/MarketingIcon'
import { useSelector } from 'react-redux'
import { getLogoSupplier } from 'src/features/SupplierdashbaordWrapperSlice'
import { supplierPortalTheme } from 'src/branding/supplierPortalTheme'

/*
import DashboardStat from 'src/features/DashboardStat/DashboardStat'
*/

const SupplierdasbaordWrapper = ({ supplierTitle, location, children }) => {
  const history = useHistory()
  const account = useSelector(state => state.auth.account)
  const AIOrderCaptureEmail = useSelector(
    state => state.auth.account.AIOrderCaptureEmail,
  )
  const [selectedKey, setSelectedKey] = useState('orders')
  useEffect(() => {
    const path = location.pathname
    if (path === '/supplier/orders') {
      setSelectedKey('orders')
    } else if (path === '/supplier/products') {
      setSelectedKey('products')
    } else if (path === '/supplier/customers') {
      setSelectedKey('customers')
    } else if (path === '/supplier/customer-invoices') {
      setSelectedKey('customer-invoices')
    } else if (path === '/supplier/incentive-scheme') {
      setSelectedKey('incentive-scheme')
    } else if (path === '/supplier/integration') {
      setSelectedKey('integration')
    } else if (path === '/supplier/marketing') {
      setSelectedKey('marketing')
    } else if (path === '/supplier/feedback') {
      setSelectedKey('feedback')
    } else if (path === '/supplier/analytics') {
      setSelectedKey('analytics')
    } else if (path.includes('/supplier/co-pilot')) {
      setSelectedKey('co-pilot')
    }
  }, [location.pathname])
  const [logoUrl, setLogoUrl] = useState('')

  console.log(location.pathname)

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const logo = await getLogoSupplier(account?.supplier[0]._id)

        setLogoUrl(logo)
      } catch (error) {
        console.error(error)
      }
    }
    fetchLogo()
  }, [])

  function signOut() {
    return () => Auth.signOut().then(() => history.push('/login'))
  }

  const navItems = useMemo(() => {
    const baseItems = [
      {
        key: 'orders',
        label: 'Orders',
        path: '/supplier/orders',
        icon: OrdersIcon,
      },
      {
        key: 'products',
        label: 'Product Files',
        path: '/supplier/products',
        icon: ProductsIcon,
      },
      {
        key: 'customers',
        label: 'Customers',
        path: '/supplier/customers',
        icon: CustomersIcon,
      },
      {
        key: 'customer-invoices',
        label: 'Customer Invoices',
        path: '/supplier/customer-invoices',
        icon: InvoicesIcon,
      },
      {
        key: 'incentive-scheme',
        label: 'Incentive Scheme',
        path: '/supplier/incentive-scheme',
        icon: IncentiveIcon,
      },
      {
        key: 'integration',
        label: 'Integration',
        path: '/supplier/integration',
        icon: IntegrationIcon,
      },
      {
        key: 'marketing',
        label: 'Marketing',
        path: '/supplier/marketing',
        icon: MarketingIcon,
      },
      {
        key: 'feedback',
        label: 'Feedback',
        path: '/supplier/feedback',
        icon: FeedbackIcon,
      },
    ]
    if (AIOrderCaptureEmail) {
      baseItems.splice(2, 0, {
        key: 'co-pilot',
        label: 'Co-Pilot',
        path: '/supplier/co-pilot',
        icon: CopilotIcon,
      })
    }
    return baseItems
  }, [AIOrderCaptureEmail])
  return (
    <SupplierPortalShell>
      <Header>
        <LeftHeader>
          <Link to='/'>
            <Logo src={OMSLogo} alt='' />
          </Link>
        </LeftHeader>

        <MidHeader>
          <VenueTitle>{supplierTitle ? supplierTitle : 'Supplier'}</VenueTitle>
        </MidHeader>

        <RightHeader>
          <Tooltip
            placement='bottomRight'
            title='Earn rewards for introducing OMS to venues. This is separate from Invite a customer, which lets a venue order from you on OMS.'
          >
            <CTAButton
              size='large'
              ghost
              className='referral-cta'
              id='btn-supplier-referral-rewards'
              onClick={() =>
                window.open(
                  'https://ordersmadesimple.com/supplier-referral',
                  '_blank',
                )
              }
            >
              <span className='referral-label-full'>Earn referral rewards</span>
              <span className='referral-label-short'>Rewards</span>
              <Tag color='red' className='referral-badge'>
                NEW
              </Tag>
            </CTAButton>
          </Tooltip>
          <CTAButton
            size='large'
            className='signout-cta'
            onClick={() => Auth.signOut().then(() => history.push('/login'))}
          >
            Sign out
          </CTAButton>
          {logoUrl ? (
            <SupplierLogo className='logo-style'>
              <img src={logoUrl} alt='Supplier Logo' />
            </SupplierLogo>
          ) : null}
        </RightHeader>
      </Header>
      <PortalBody>
        <Sider width={248} className='supplier-sider'>
          <NavList>
            {navItems.map(item => {
              const Icon = item.icon
              const isActive = selectedKey === item.key
              return (
                <li key={item.key}>
                  <NavLink to={item.path} $active={isActive} title={item.label}>
                    <Icon size='22px' />
                    <span className='nav-label'>{item.label}</span>
                  </NavLink>
                </li>
              )
            })}
            <li>
              <NavAction type='button' onClick={signOut()} title='Sign Out'>
                <SignoutIcon size='22px' />
                <span className='nav-label'>Sign Out</span>
              </NavAction>
            </li>
          </NavList>
        </Sider>
        <Content>{children}</Content>
      </PortalBody>
    </SupplierPortalShell>
  )
}

const SupplierPortalShell = styled(Layout)`
  --sp-color-bg: ${supplierPortalTheme.colors.bg};
  --sp-color-surface: ${supplierPortalTheme.colors.surface};
  --sp-color-text: ${supplierPortalTheme.colors.text};
  --sp-color-muted: ${supplierPortalTheme.colors.muted};
  --sp-color-primary: ${supplierPortalTheme.colors.primary};
  --sp-color-border: ${supplierPortalTheme.colors.border};
  --sp-color-header: ${supplierPortalTheme.colors.header};
  --sp-color-nav: ${supplierPortalTheme.colors.nav};
  --sp-radius-card: ${supplierPortalTheme.radii.card};
  --sp-radius-control: ${supplierPortalTheme.radii.control};
  --sp-shadow-card: ${supplierPortalTheme.shadows.card};
  --sp-shadow-modal: ${supplierPortalTheme.shadows.modal};
  --sp-space-xxs: ${supplierPortalTheme.spacing.xxs};
  --sp-space-xs: ${supplierPortalTheme.spacing.xs};
  --sp-space-sm: ${supplierPortalTheme.spacing.sm};
  --sp-space-md: ${supplierPortalTheme.spacing.md};
  --sp-space-lg: ${supplierPortalTheme.spacing.lg};
  --sp-space-xl: ${supplierPortalTheme.spacing.xl};
  --sp-space-xxl: ${supplierPortalTheme.spacing.xxl};
  min-height: 100vh;
  background: var(--sp-color-bg);
  color: var(--sp-color-text);
  font-family: ${supplierPortalTheme.typography.fontFamily};
  font-size: ${supplierPortalTheme.typography.baseSize};
  line-height: 1.5;
`

const PortalBody = styled(Layout)`
  min-height: calc(100vh - 96px);
  background: var(--sp-color-bg);

  @media (max-width: 890px) {
    .supplier-sider.ant-layout-sider {
      flex: 0 0 72px !important;
      max-width: 72px !important;
      min-width: 72px !important;
      width: 72px !important;
      padding: var(--sp-space-md) var(--sp-space-xs);
    }

    .nav-label {
      display: none;
    }

    a,
    button {
      justify-content: center;
      padding-left: var(--sp-space-sm);
      padding-right: var(--sp-space-sm);
    }
  }
`

const SupplierLogo = styled.div`
  flex-shrink: 0;

  img {
    width: auto;
    height: 64px;
    border-radius: var(--sp-radius-card);
    margin-left: var(--sp-space-sm);
    object-fit: contain;
    background: var(--sp-color-surface);
    padding: var(--sp-space-xxs);
    box-shadow: var(--sp-shadow-card);
  }

  @media (max-width: 1024px) {
    img {
      width: 48px;
      height: 48px;
      margin-left: var(--sp-space-xs);
    }
  }

  @media (max-width: 700px) {
    display: none;
  }
`

const Link = styled(ReactLink).withConfig({
  shouldForwardProp: prop => prop !== '$active',
})``

const Sider = styled(Layout.Sider)`
  && {
    background: var(--sp-color-nav);
    padding: var(--sp-space-xl) var(--sp-space-md);
    border-right: 1px solid var(--sp-color-border);
  }
`

const navItemStyles = css`
  width: 100%;
  display: flex;
  align-items: center;
  gap: var(--sp-space-sm);
  padding: var(--sp-space-sm) var(--sp-space-md);
  border-radius: var(--sp-radius-control);
  font-weight: 600;
  font-size: 15px;
  line-height: 1.4;
  text-decoration: none;
  color: var(--sp-color-text);
  transition: background 0.2s ease, color 0.2s ease;
  svg {
    flex-shrink: 0;
  }
`

const NavLink = styled(Link)`
  ${navItemStyles}
  ${({ $active }) =>
    $active
      ? css`
          background: rgba(14, 165, 233, 0.12);
          color: var(--sp-color-primary);
        `
      : css`
          &:hover {
            background: rgba(15, 23, 42, 0.05);
          }
        `}
`

const NavAction = styled.button`
  ${navItemStyles}
  border: none;
  background: transparent;
  cursor: pointer;
  &:hover {
    background: rgba(220, 38, 38, 0.08);
    color: var(--sp-color-danger);
  }
`

const NavList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--sp-space-xs);
`

const Header = styled(Layout.Header)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: var(--sp-space-sm);
  min-height: 96px;
  height: auto !important;
  background: var(--sp-color-header);
  padding: var(--sp-space-sm) var(--sp-space-xxl);
  box-shadow: var(--sp-shadow-card);
  overflow: visible;

  @media (max-width: 1440px) {
    padding: var(--sp-space-sm) var(--sp-space-lg);
  }

  @media (max-width: 1024px) {
    padding: var(--sp-space-sm) var(--sp-space-md);
  }

  @media (max-width: 890px) {
    padding: var(--sp-space-sm);
    row-gap: var(--sp-space-xs);
  }

  @media (max-width: 700px) {
    padding: var(--sp-space-xs) var(--sp-space-sm);
  }
`

const Logo = styled.img`
  max-height: 100%;
  height: 64px;
  margin-top: 0;
  display: block;

  @media (max-width: 890px) {
    height: 48px;
  }
`

const Content = styled(Layout.Content)`
  min-height: calc(100vh - 100px) !important;
  background: var(--sp-color-bg);
  padding: var(--sp-space-xl);
  min-width: 0;
  overflow-x: auto;

  @media (min-width: 1400px) {
    padding: var(--sp-space-xxl);
  }
  .ant-card,
  .ant-table-wrapper,
  .ant-table {
    background: var(--sp-color-surface);
    border-radius: var(--sp-radius-card);
    box-shadow: var(--sp-shadow-card);
  }
  .ant-table {
    border: 1px solid var(--sp-color-border);
  }
  .ant-table-thead > tr > th {
    font-weight: 600;
    color: var(--sp-color-muted);
    background: var(--sp-color-surface);
    border-bottom: 1px solid var(--sp-color-border);
    padding: var(--sp-space-sm) var(--sp-space-md);
    white-space: nowrap;
  }
  .ant-table-tbody > tr > td {
    padding: var(--sp-space-sm) var(--sp-space-md);
  }
  .ant-table-tbody > tr:hover > td {
    background: rgba(14, 165, 233, 0.06);
  }
  @media (max-width: 1024px) {
    min-height: calc(100vh - 150px) !important;
    padding: var(--sp-space-md);
  }
  @media (max-width: 700px) {
    padding: var(--sp-space-sm);
  }
`

const LeftHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 0 0 auto;
  padding-right: var(--sp-space-sm);
`

const RightHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
  gap: var(--sp-space-xs);
  max-width: none;

  .referral-label-short {
    display: none;
  }

  @media (max-width: 1024px) {
    .referral-label-full {
      display: none;
    }
    .referral-label-short {
      display: inline;
    }
  }

  @media (max-width: 890px) {
    width: 100%;
    justify-content: flex-start;
    order: 3;
  }
`

const MidHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 1 160px;
  min-width: 0;
  max-width: 100%;
  line-height: 1.2;
  padding-right: var(--sp-space-md);

  @media (max-width: 890px) {
    flex: 1 1 120px;
    padding-right: 0;
  }
`

const VenueTitle = styled(H4)`
  text-align: left;
  color: ${supplierPortalTheme.colors.surface};
  width: 100%;
  max-width: 100%;
  margin: 0;
  font-weight: 900;
  font-size: 22px;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 1024px) {
    font-size: 18px;
  }

  @media (max-width: 700px) {
    font-size: 16px;
  }
`

const CTAButton = styled(Button)`
  height: 44px !important;
  border-radius: var(--sp-radius-control);
  font-weight: 600;
  padding: 0 var(--sp-space-md);
  flex-shrink: 0;
  display: inline-flex !important;
  align-items: center;
  white-space: nowrap;

  &.ant-btn-primary {
    background: var(--sp-color-primary);
    border-color: var(--sp-color-primary);
    color: var(--sp-color-surface);
  }

  .referral-badge {
    margin-left: 8px;
    margin-right: 0;
    line-height: 18px;
    flex-shrink: 0;
  }

  @media (max-width: 890px) {
    height: 40px !important;
    padding: 0 var(--sp-space-sm);
  }

  @media (max-width: 700px) {
    .referral-badge {
      display: none;
    }
  }
`

export default SupplierdasbaordWrapper
